import _ from 'underscore';

const enumBlackList = {
  LanguageCode: ['NO'],
};

export function processFilters(fields, ColumnsSchema) {
  return _.mapObject(fields, (rawField, rawKey) => {
    const field = {
      ...rawField,
      filterable: true,
    };

    if (ColumnsSchema && ColumnsSchema[rawKey]) {
      field.displayType = ColumnsSchema[rawKey].DisplayType;
    }

    if (enumBlackList[rawKey]) {
      field.enum = _.difference(field.enum, enumBlackList[rawKey]);
    }

    return field;
  });
}
